import { IRouteRoles, Role } from 'core/config/roles';
import { useAuthState } from 'core/providers/AuthProvider';
import { useDialog } from 'core/providers/DialogProvider';
import SetPasswordDialog from 'modules/auth/set-password-dialog/set-password-dialog';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AdminLayout from 'shared/components/layout/admin-layout';

const RoleHandler = ({ roles }: IRouteRoles) => {
  const location = useLocation();
  const { userRoles, userData } = useAuthState();

  const dialog = useDialog();

  useEffect(() => {
    if (userData?.resetPassword) {
      dialog?.openDialog(<SetPasswordDialog />);
    }
  }, [dialog, userData?.resetPassword]);

  if (roles && !roles.some((role) => userRoles?.includes(role))) {
    return <Navigate to='' state={{ from: location }} replace />;
  }

  // Only render the bare driver shell when the user has *exclusively* driver roles.
  // Users who also hold an admin role (e.g. super admin + logistics driver) must keep
  // the AdminLayout so they retain the sidebar/header and can access all portal items.
  const driverRoles = [Role.PHARMACY_DRIVER, Role.LOGISTICS_DRIVER];
  const hasOnlyDriverRoles = !!userRoles?.length && userRoles.every((role) => driverRoles.includes(role));

  if (hasOnlyDriverRoles) {
    return <Outlet />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
};

export default RoleHandler;
